export default "__VITE_ASSET__DOHerLy3__"